export default "__VITE_ASSET__77283455__"